import { useAppQuery } from '@/helpers/api/query'
import { format } from 'date-fns'

import { createInstance } from '@/helpers/api/base'
import { useDateStore } from '@/components/DateInput'
import { VehicleAssignmentsHistory } from '@/types/vehicleAllocation'
import { useGarageStore } from '@/modules/FindGarage'
import { useMemo } from 'react'
import { useAuthStore } from '@/store/auth-store'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'
import { useAreaStore, useGetAreas } from '@/modules/Areas'
import { Role } from '@/types/auth'
import { useWorkstationStore } from '@/modules/Workstation/store'

const GET_VEHICLE_ASSIGNMENTS_HISTORY_KEY = 'GET_VEHICLE_ASSIGNMENTS_HISTORY'

export const useGetVehicleAssignmentsHistory = () => {
    const { role } = useAuthStore()
    const { routes } = useWorkstationStore()
    const { garage } = useGarageStore()
    const { source } = useReaderLogStore()
    const { selectedAreaCode } = useAreaStore()
    const { data: areas = [] } = useGetAreas()
    const { date } = useDateStore()
    const formattedDate = format(date, 'yyyy/MM/dd')

    const routesToLoad = useMemo(() => {
        if (role === Role.MileageClerk) {
            return garage?.routes || []
        }

        if (role === Role.PerformanceManager || role === Role.Controller) {
            return routes.map((item) => item.route)
        }

        if (role === Role.Reader) {
            return source?.routes.map((item) => item.route)
        }

        const selectedArea = areas?.find((item) => item.code === selectedAreaCode)

        if (!selectedArea) {
            return []
        }

        return selectedArea.workstations.flatMap((item) => item.routes.map((route) => route.route))
    }, [role, garage, source, selectedAreaCode, areas, routes])

    return useAppQuery<{ assignments: VehicleAssignmentsHistory[] }>({
        queryKey: [GET_VEHICLE_ASSIGNMENTS_HISTORY_KEY, formattedDate, routesToLoad],
        queryFn: ({ queryKey }) =>
            createInstance({
                url: '/fleets/vehicle-assignments-history',
                method: 'GET',
                params: {
                    Date: queryKey[1],
                    Routes: queryKey[2],
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        refetchOnMount: false,
        staleTime: 60 * 1024,
    })
}
